import { render } from "./AddItemConfiguration.vue?vue&type=template&id=8e1979ce"
import script from "./AddItemConfiguration.vue?vue&type=script&lang=js"
export * from "./AddItemConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__